<template>
  <div id="homeAdmin">
    <header class="app-header navbar">
      <button
        class="navbar-toggler mobile-sidebar-toggler d-lg-none mr-auto disableHide"
        type="button"
      >
        <span class="navbar-toggler-icon"></span>
      </button>
      <router-link to="/admin" class="navbar-brand" />
      <button class="navbar-toggler sidebar-minimizer d-md-down-none disableHide" type="button">
        <span class="navbar-toggler-icon"></span>
      </button>
      <ul class="nav navbar-nav ml-auto">
        <li class="nav-item text-right">
          <a
            class="nav-link"
            href="#"
            role="button"
            aria-haspopup="true"
            aria-expanded="false"
          >
            <i class="icon-question" @click="openFaqModal()"></i>
          </a>
        </li>
        <li class="nav-item dropdown d-md-down-none">
          <a
            class="nav-link"
            data-toggle="dropdown"
            href="#"
            role="button"
            aria-haspopup="true"
            aria-expanded="false"
            onclick="javascript:notificationHelpers.readAll();"
          >
            <i class="icon-bell"></i>
            <span id="lblNumberNotification" class="badge badge-pill badge-danger"></span>
          </a>
          <div id="divNotification" class="dropdown-menu dropdown-menu-right"></div>
        </li>
        <li class="nav-item dropdown">
          <a
            class="nav-link"
            data-toggle="dropdown"
            href="#"
            role="button"
            aria-haspopup="true"
            aria-expanded="false"
          >
            <i class="icon-user icons"></i>
            <span id="navbarUsername"></span>
          </a>
          <div class="dropdown-menu dropdown-menu-right">
            <div class="dropdown-header text-center">
              <strong>{{ account }}</strong>
            </div>
            <a class="dropdown-item" href="/admin/logout">
              <i class="icon-logout icons"></i>&nbsp;
              <label>{{ logout }}</label>
            </a>
          </div>
        </li>
        <div style="width:15px"></div>
      </ul>
    </header>
    <div class="app-body">
      <div class="sidebar" style="z-index:4;">
        <nav class="sidebar-nav">
          <ul class="nav" id="menu">
            <div v-for="menu in menus" :key="menu.id">
              <li v-if="menu.nextLevel.length == 0" class="nav-item">
                <router-link :to="menu.url" class="nav-link" @click.native="clickMenu">
                  <i v-if="menu.cssIcon" class="nav-icon" :class="menu.cssIcon"></i>
                  {{ menu.label }}
                </router-link>
              </li>
              <li v-else class="nav-item nav-dropdown" :data-attr-id="'id-' + menu.id" >
                <a class="nav-link nav-dropdown-toggle" href="#" @click="clickMenuOpen(menu.id)">
                  <i v-if="menu.cssIcon" class="nav-icon" :class="menu.cssIcon"></i>
                  {{ menu.label }}
                </a>
                <ul class="nav-dropdown-items">
                  <div v-for="menuChildren in menu.nextLevel" :key="menuChildren.id">
                    <li v-if="menuChildren.nextLevel.length == 0" class="nav-item">
                      <router-link
                        :to="menuChildren.url"
                        @click.native="clickMenu"
                        class="nav-link"
                      >
                        <i
                          v-if="menuChildren.cssIcon"
                          class="nav-icon"
                          :class="menuChildren.cssIcon"
                        ></i>
                        {{ menuChildren.label }}
                      </router-link>
                    </li>
                    <li v-else class="nav-item nav-dropdown">
                      <a class="nav-link nav-dropdown-toggle nav-father" href="#">
                        <i
                          v-if="menuChildren.cssIcon"
                          class="nav-icon"
                          :class="menuChildren.cssIcon"
                        ></i>
                        {{ menuChildren.label }}
                      </a>
                      <ul class="nav-dropdown-items nav-children">
                        <li
                          v-for="menuChildrenChildren in menuChildren.nextLevel"
                          :key="menuChildrenChildren.id"
                          class="nav-item"
                        >
                          <router-link
                            :to="menuChildrenChildren.url"
                            @click.native="clickMenu"
                            class="nav-link"
                          >
                            <i
                              v-if="menuChildrenChildren.cssIcon"
                              class="nav-icon"
                              :class="menuChildrenChildren.cssIcon"
                            ></i>
                            {{ menuChildrenChildren.label }}
                          </router-link>
                        </li>
                      </ul>
                    </li>
                  </div>
                </ul>
              </li>
            </div>
          </ul>
        </nav>
        <button id="btnMenu" class="sidebar-minimizer brand-minimizer" type="button"></button>
      </div>
      <!--Modal faq -->
      <div class="modal" id="modalFaq" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true" >
        <div class="modal-dialog modal-lg" role="document">
          <div class="modal-content padding">
            <div class="modal-header text-center">
              <h4 class="modal-title w-100 font-weight-bold">
                Faq
              </h4>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close" >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body mx-12">
              <div class="md-form mb-12">
                <div class="row">
                  <div class="col-12" v-if="faqList.length>0">
                    <div id="accordion" class="faqAccordion">
                      <div class="card" v-for="faqLists in faqList" v-bind:key="faqLists.id">
                        <div class="card-header" :id="'headingOne' + faqLists.id">
                          <h5 class="mb-0">
                            <button class="btn btn-link" data-toggle="collapse" :data-target="'#collapseOne' + faqLists.id" aria-expanded="true" :aria-controls="'collapseOne' + faqLists.id">
                              {{faqLists.shortcode}}
                            </button>
                          </h5>
                        </div>
                        <div :id="'collapseOne'+ faqLists.id" class="collapse" :aria-labelledby="'headingOne'+ faqLists.id" data-parent="#accordion">
                          <div class="card-body">
                            <p class="descriprion">{{faqLists.description}}</p>
                            <label>Dove</label>
                            <p>{{faqLists.where}}</p>
                            <label>Come</label>
                            <p>{{faqLists.how}}</p>
                            <label>Cosa fa</label>
                            <p>{{faqLists.what}}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-12 text-center" v-else>
                    <h3>Nessun suggerimento trovato</h3>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--Modal faq -->
      <div>
        
      </div>
      <!-- Main content -->
      <main id="main" class="main">
        <router-view></router-view>
      </main>
    </div>

    <footer class="app-footer" style="z-index:0;">
      <span class="ml-auto">
        <a
          href="https://tecnotrade.com"
          title="Realizzazione siti internet Modena e Bologna"
          style="font-size: .9rem;color:#000;"
        >
          <span style="color:#009246;">Made</span> in
          <span style="color:#CE2B37;">Italy</span> with
          <i class="fa fa-heart" aria-hidden="true" style="color:#C72123"></i>
          by Tecnotrade
        </a>
      </span>
    </footer>
  </div>
</template>

<script>
export default {
  name: "adminHome",
  data: function() {
    return {
      faqList: [],
    }
  },
  computed: {
    menus: function() {
      return storageData.sMenu();
    
    },
    account: function() {
      return dictionaryHelpers.getDictionary("Account");
    },
    logout: function() {
      return dictionaryHelpers.getDictionary("Logout");
    }
  },
  created: function() {
    var adminHome = this;
    if (functionHelpers.isValued(storageData.sTokenKey())) {
      //loginHelpers.refreshToken();
      if (functionHelpers.isValued(storageData.sUserName())) {
        userServices.checkGroupUser(storageData.sUserName(),function(result) {
          //se l'utente che naviga non è admin allora redirect
          if(!result.data){
            window.location = '/';
          }else{
            var ln = storageData.sIdLanguage();
            faqServices.getAll(ln, function(result) {
              adminHome.faqList = result.data;
              spinnerHelpers.hide();
            });
          }
        });
      }
    } else {
      loginHelpers.disconnect();
    }
  },
  mounted() {
    window.mainHelpers = require("@/helpers/main.js");
    $("#bodyMain").attr("style", "background-color: #e4e5e6");
    $("#navbarUsername").text(" " + storageData.sUserName());
    // menuHelpers.showAdmin();
    // Minimized menu on click
    if (!$("body").hasClass("sidebar-minimized")) {
      $("#btnMenu").trigger("click");
    }
    //this.initializeEnvironment();
  },
  methods: {
    openFaqModal: function() {
      $("#modalFaq").modal("show");
    },
    clickMenu: function() {
      // Minimized menu on click
      if (!$("body").hasClass("sidebar-minimized")) {
        $("#btnMenu").trigger("click");
      }
      // Close menù from mobile
      $(".navbar-toggler.mobile-sidebar-toggler.d-lg-none.mr-auto").click();
    },
    clickMenuOpen: function(id) {
      if($(".nav-dropdown[data-attr-id='" + id + "']").hasClass('open')){
        $(".nav-dropdown[data-attr-id='" + id + "']").removeClass('open');
      }else{
        $(".nav-dropdown").removeClass('open');
        $(".nav-dropdown[data-attr-id='" + id + "']").addClass('open');
      }
    },
    getWithoutChildren: function() {},
    initializeEnvironment:  function() {
      $('#modalSettingEnvironment').modal('show');
      $('#modalSettingEnvironment').css('background','rgba(0,0,0,0.5)');
      $('header').css('filter', 'blur(2px)');
      $('.app-body').css('filter', 'blur(2px)');
      $('footer').css('filter', 'blur(2px)');
    },
  }
};
</script>

<style>
.app-footer {
  position: fixed;
  bottom: 0;
  width: 100%;
  text-align: right;
  margin-left: 0px !important;
}

.sidebar-minimized .nav-father:hover ~ .nav-children {
  position: fixed !important;
  width: 200px;
  margin-left: 200px;
  margin-top: -48px;
}

.sidebar-minimized .nav-children {
  position: fixed !important;
  transition: 5s all;
}

.sidebar-minimized .nav-children:hover {
  position: fixed !important;
  width: 200px;
  margin-left: 200px;
  margin-top: -48px;
}

.box-environment {
    border: 3px solid #ededed;
    padding: 10px;
    border-radius: 3px;
    box-shadow: 0px 3px 15px -5px rgba(0,0,0,0.2);
}
#modalSettingEnvironment .modal-lg {
    max-width: 900px;
}
.box-environment button{
  background:#000;
}

.sidebar-minimized .sidebar .nav-dropdown-items .nav-item{
  width:200px;
}
.sidebar-minimized .sidebar .nav-children .nav-item,
.sidebar-minimized .nav-father ~ .nav-children a {
  padding-left:0px !important;
}
.nav-dropdown .nav-dropdown .nav-dropdown-items a {
  padding-left:30px;
}

.faqAccordion .card-header{
      padding: 0;
}
.faqAccordion .card-header .btn-link{
  color:#222;
}

.faqAccordion .card{
  margin-bottom:5px;
}
.faqAccordion p{
  margin-bottom:5px;
  font-size:16px;
}

.faqAccordion label{
  margin-bottom:2px;
  font-size:10px;
  font-weight: bold;
  text-transform: uppercase;
  border-bottom:2px solid #ededed;
}
</style>
